function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "options"
}, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "m3 6h3.185c.414 1.161 1.513 2 2.815 2s2.401-.839 2.815-2h9.185c.553 0 1-.447 1-1s-.447-1-1-1h-9.185c-.414-1.161-1.513-2-2.815-2s-2.401.839-2.815 2h-3.185c-.553 0-1 .447-1 1s.447 1 1 1zm6-2c.552 0 1 .448 1 1s-.448 1-1 1-1-.448-1-1 .448-1 1-1z"
}), /*#__PURE__*/React.createElement("path", {
  d: "m21 11h-3.185c-.414-1.161-1.513-2-2.815-2s-2.401.839-2.815 2h-9.185c-.553 0-1 .447-1 1s.447 1 1 1h9.185c.414 1.161 1.514 2 2.815 2s2.401-.839 2.815-2h3.185c.553 0 1-.447 1-1s-.447-1-1-1zm-6 2c-.552 0-1-.448-1-1s.448-1 1-1 1 .448 1 1-.448 1-1 1z"
}), /*#__PURE__*/React.createElement("path", {
  d: "m21 18h-9.185c-.414-1.161-1.514-2-2.815-2s-2.401.839-2.815 2h-3.185c-.553 0-1 .447-1 1s.447 1 1 1h3.185c.414 1.161 1.513 2 2.815 2s2.401-.839 2.815-2h9.185c.553 0 1-.447 1-1s-.447-1-1-1zm-12 2c-.552 0-1-.448-1-1s.448-1 1-1 1 .448 1 1-.448 1-1 1z"
})));

var Svg086Options = function Svg086Options(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 512,
    viewBox: "0 0 24 24",
    width: 512,
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(Svg086Options, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/086-options.b4eee4d1.svg";
export { ForwardRef as ReactComponent };